import { Grid } from '@mui/material';
import React from 'react';
import { useNavigate } from "react-router-dom"
import ScopeRegionConfigurationTable from '../AppGrid/ScopeRegionConfigurationTable';


export const ScopeRegionConfiguration = () => {
	const navigate = useNavigate();

	return (
		<Grid container>
			<Grid size={12}>
				<ScopeRegionConfigurationTable onOpenForm={({ record = {}, id }) => {
					if (record?.ScopeModelId) {
						navigate(`/region?ScopeModelId=${record.ScopeModelId}`)
					}
				}} />
			</Grid>
		</Grid>
	);
}

